import script from "./DefaultButton.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultButton.vue?vue&type=script&setup=true&lang=js"

import "./DefaultButton.vue?vue&type=style&index=0&id=54d01115&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54d01115"]])

export default __exports__